// Static menu data. Click handling lives in the consumer
// (components/Layout/Header/MobileMenu.js), keyed off section title.
export const menuData = [
  {
    title: "DISCIPLINE",
    items: [
      { label: "Barrel Racing", value: "barrel_racing" },
      { label: "Cutting", value: "cutting" },
      { label: "Ranch Riding", value: "ranch_riding" },
      { label: "Reining", value: "reining" },
      { label: "Roping", value: "roping" },
      { label: "Team Penning Sorting", value: "team_penning_sorting" },
      { label: "Trail Riding", value: "trail_riding" },
      { label: "Endurance", value: "western_endurance_riding" },
      { label: "Western Pleasure", value: "western_pleasure" },
    ],
  },
  {
    title: "BRANDS",
    items: [
      { label: "Cactus", value: "cactussaddlery" },
      { label: "Billy Cook", value: "billycook" },
    ],
  },
];
